<template>
  <div>
    <el-dialog title="查看笔记"
               :visible.sync="dialogFormVisible"
               width="950px"
               top="10px"
               @close="handleClose()"
               @open="open()">
      <div class="content">
        <div class="auditContent">
          <div class="iframContent">
            <iframe :src="currentSrc"
                    width="300px"
                    id="your-iframe-id"
                    frameborder="1"
                    style=" border: 1px solid black;"
                    height="600px"
                    @load="handleIframeLoad"></iframe>
          </div>
        </div>
        <div class="auditRight">
          <p class="audirTop"><span class="blue"></span> <span>新建评论</span></p>
          <el-form ref="userForm"
                   label-width="50px"
                   style="width:300px"
                   class="userForm">
            <el-form-item label="评论类型"
                          label-width="86px">
              <el-radio-group v-model="level"
                              @change="radioCommentChange">
                <el-radio class="input-radio"
                          :label="1">
                  新建评论
                </el-radio>
                <el-radio class="input-radio"
                          :label="2">
                  回复评论
                </el-radio>
              </el-radio-group>
            </el-form-item>
            <el-tag closable
                    v-if="chooseCommentList.length >0"
                    style="marginLeft:20px;marginTop:-20px">{{chooseCommentList[0].content}}</el-tag>

            <el-form-item label="评论内容"
                          label-width="86px"
                          style="marginTop:10px">
              <el-input v-model="userForm.content"
                        type="textarea"
                        :rows="4"
                        style="width:300px;"
                        clearable></el-input>
            </el-form-item>
            <el-form-item label="发布人"
                          label-width="86px">
              <el-radio-group v-model="userForm.type"
                              @change="radioChange">
                <el-radio class="input-radio"
                          :label="1">
                  用户
                </el-radio>
                <el-radio class="input-radio"
                          :label="2">
                  虚拟用户
                </el-radio>
              </el-radio-group>
              <div v-if="virtUser.length>0">
                <el-tag v-for="tag in virtUser"
                        :key="tag.name"
                        closable>
                  {{tag.nickname}}{{tag.mobile ?tag.mobile:''}}
                </el-tag>
              </div>
              <div v-if="realUser.length>0">
                <el-tag v-for="tag in realUser"
                        :key="tag.name"
                        closable>
                  {{tag.nickname}}/{{tag.mobile ?tag.mobile :''}}
                </el-tag>
              </div>
            </el-form-item>
            <el-form-item label="发布时间"
                          label-width="86px">
              <el-date-picker v-model="userForm.admin_finger_create_time"
                              type="datetime"
                              style="width: 360px"
                              format="yyyy-MM-dd HH:mm"
                              value-format="timestamp"
                              placeholder="选择日期时间" />
              <div class="timeGroup">
                <div v-for="range in timeRanges"
                     :key="range.id"
                     @click="handleRangeSelect(range)">
                  <span class="timeItem"> {{ range.label }}</span> <span v-if="range.id !=5">|</span>
                </div>
              </div>
            </el-form-item>

          </el-form>
          <p class="audirTop"><span class="blue"></span> <span>基础评论量</span></p>
          <el-form ref="userForm"
                   label-width="50px"
                   style="width:300px"
                   class="userForm">
            <el-form-item label="基础评论量"
                          label-width="86px">
              <div class="rangeContent">
                <div v-for="(item,index) in NumRanges"
                     :key="index"
                     class="rangeItem"
                     :class="{'active':item.flag}"
                     @click="handleLike(item)">{{item.label}}

                  <img src="https://upload.kaoyanbox.net/0474a5bcc4fed067ae81ab68267e6c68.png"
                       class="checkImg"
                       v-if="item.flag" />
                </div>
              </div>
            </el-form-item>
            <el-form-item label="评论身份"
                          prop="order_no"
                          label-width="86px">
              <el-select v-model="userForm.base_comment_educate_type"
                         placeholder="请选择"
                         clearable
                         style="width:360px;">
                <el-option v-for="item in identity "
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="评论分类"
                          prop="order_no"
                          label-width="86px">
              <el-checkbox-group v-model="resultCheck"
                                 style="width:360px">
                <el-checkbox :label="index"
                             v-for="(item,index) in  result"
                             :key="index">{{item.name}}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-form>
          <div class="footer">
            <div class="cancle"
                 @click="handleClose()">取消</div>

            <div class="confirm"
                 @click="submit()">确定</div>
          </div>
        </div>
      </div>

    </el-dialog>

    <el-dialog title="选择评论"
               :visible.sync="commentShow"
               :append-to-body="true"
               width="900px">
      <el-table :data="commentResult"
                style="width: 100%;margin-bottom: 20px;"
                row-key="id"
                border
                ref="commentTable"
                :default-expand-all="false"
                @expand-change="handleExpand"
                @row-click="clickRow"
                @selection-change="handleSelectionChange"
                :tree-props="{children: 'children'}">
        <el-table-column type="selection"
                         width="55"
                         align="center" />
        <el-table-column prop="id"
                         label="ID"
                         align="center"
                         width="90">
        </el-table-column>
        <el-table-column label="发布人"
                         width="170"
                         align="center"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.create_user_obj.nickname }}/{{scope.row.create_user_obj.mobile}}</span></template>
        </el-table-column>
        <el-table-column label="评论内容"
                         width="200"
                         align="left"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.content }}</span></template>
        </el-table-column>
        <el-table-column label="评论对象"
                         width="170"
                         align="center"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.replyed_user_obj">{{ scope.row.replyed_user_obj.nickname }}/{{scope.row.replyed_user_obj.mobile}}</span>
            <span v-else>经验</span>
          </template>
        </el-table-column>

        <el-table-column label="发布时间"
                         align="center"
                         width="200"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            {{
                scope.row.create_time
                  ? $moment(scope.row.create_time).format("YYYY-MM-DD")
                  : ""
              }}
          </template>
        </el-table-column>
      </el-table>
      <div style="display:flex;justify-content: space-between;"><el-pagination background
                       layout="total, prev, pager, next, sizes, jumper"
                       :current-page="Number(commentQuery.pageIndex)"
                       :page-sizes="[10, 20, 50, 100, 500]"
                       :page-size="Number(commentQuery.pageSize)"
                       :total="Number(commentTotal)"
                       @size-change="handleSizeComment"
                       @current-change="handlePageComment">
        </el-pagination>
        <div class="footers">
          <div class="cancle"
               @click="concleComment()">取消</div>
          <div class="confirm"
               @click="confirmComment()">确定</div>
        </div>
      </div>
    </el-dialog>
    <Virtualuser :isVisible="VirtualVisible"
                 @close="handleCloses()"
                 @virtChoose="virtChoose" />
    <Realname :isVisible="realUserVisible"
              @close="handleUserClose()"
              @realChoose="realChoose" />

  </div>
</template>
<script>
import Virtualuser from '@/components/dialog/virtualUser'
import Realname from '@/components/dialog/realnameUser'
import { commentCrtaed, noteOneList } from '@/api/senior'
import { categoryList } from '@/api/note'
import { noteAdminList, noteTwoList } from '@/api/senior'
import { configureList } from '@/api/operation'

export default {
  components: { Virtualuser, Realname },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    detailId: {
      type: Number,
      default: () => {
        return null
      },
    },
  },
  data() {
    return {
      level: 1,
      replayContent: [],
      commentResult: [],
      commentTotal: 10,
      commentQuery: { pageIndex: 1, pageSize: 10 },
      commentShow: false,
      replayValue: '',
      VirtualVisible: false,
      realUserVisible: false,
      currentSrc: '',
      dialogFormVisible: this.isVisible,
      userForm: { type: 0, base_comment_educate_type: '0' },
      virtUser: [],
      realUser: [],
      // 1. 定义时间范围选项
      timeRanges: [
        { id: 1, label: '0-1小时前', minHours: 0, maxHours: 1 },
        { id: 2, label: '1-3小时前', minHours: 1, maxHours: 3 },
        { id: 3, label: '3-6小时前', minHours: 3, maxHours: 6 },
        { id: 4, label: '6-12小时前', minHours: 6, maxHours: 12 },
        { id: 5, label: '12-24小时前', minHours: 12, maxHours: 24 },
      ],
      NumRanges: [
        { id: 1, label: '0-5个', minHours: 0, maxHours: 5, flag: false },
        { id: 2, label: '6-10个', minHours: 6, maxHours: 10, flag: false },
        { id: 3, label: '11-20个', minHours: 11, maxHours: 20, flag: false },
        { id: 4, label: '21-50个', minHours: 21, maxHours: 50, flag: false },
      ],
      identity: [
        {
          label: '不区别身份',
          value: '0',
        },
        {
          label: '学生',
          value: '1',
        },
        {
          label: '学长',
          value: '2',
        },
      ],
      // 响应式变量，用于存储当前选中的范围和计算结果
      selectedRange: null,
      commentNum: null,
      timeResult: null,
      configureList: [],
      isStudent: '',
      result: [],
      resultCheck: [],
      rangeNum: null,
      target_note_comment_id: null,
      twoId: {},
      chooseCommentList: [],
    }
  },
  watch: {
    isVisible(val) {
      this.dialogFormVisible = val
    },
  },
  methods: {
    radioCommentChange(e) {
      if (e == 2) {
        this.chooseComment()
      }
    },
    oneComment() {
      let data = {
        pageSize: this.commentQuery.pageSize,
        pageIndex: this.commentQuery.pageIndex,
        note_id: this.detailId,
      }
      noteOneList(data).then((res) => {
        res.list.map((item) => {
          item.children = []
          if (item.level_one_first_row) {
            item.children.push(item.level_one_first_row)
          }
        })
        this.commentTotal = res.count
        this.commentResult = res.list.sort(
          (a, b) => b.create_time - a.create_time
        )
      })
    },
    handleSizeComment(val) {
      this.$set(this.commentQuery, 'pageSize', val)
      localStorage.setItem('pageSize', val)
      this.oneComment()
    },
    handlePageComment(val) {
      this.$set(this.commentQuery, 'pageIndex', val)
      this.oneComment()
    },
    chooseComment() {
      this.commentShow = true
    },
    handleExpand(val) {
      this.twoId = val
      this.twoComment()
    },
    // 点击一行时选中
    clickRow(row) {
      // 单选选中行
      if (this.chooseCommentList[0] == row) {
        // 取消
        this.chooseCommentList = []
        this.$refs.commentTable.clearSelection()
      } else {
        // 选择
        this.chooseCommentList = [row]
        this.$refs.commentTable.clearSelection()
        this.$refs.commentTable.toggleRowSelection(row, true)
      }
    },
    handleSelectionChange(val) {
      // this.chooseCommentList = val
      // if (val.length > 1) {
      //   const table = this.$refs.commentTable
      //   // 1. 清空所有已选中的行
      //   table.clearSelection()
      //   // 2. 仅选中当前点击的行
      //   table.toggleRowSelection(val, true)
      // }
      if (val.length > 0) {
        this.chooseCommentList = val
        this.target_note_comment_id = val[0].id
      }
    },
    //获取二级评论列表
    twoComment() {
      let data = {
        isPaging: 0,
        parent_level_one_id: this.twoId.id,
      }
      noteTwoList(data).then((res) => {
        this.commentResult.map((v) => {
          if (v.id == res.list[0].parent_level_one_id) {
            v.children = res.list.sort((a, b) => b.create_time - a.create_time)
          }
        })
      })
    },

    getCommentList() {
      let data = {
        note_id: this.detailId,
        isPaging: 0,
      }
      noteOneList(data).then((res) => {
        this.replayContent = res.list
      })
    },

    getCategoryList() {
      categoryList({ isPaging: 0 }).then((res) => {
        this.result = res.list
      })
    },
    handleIframeLoad() {},
    handleClose() {
      this.replayValue = ''
      this.target_note_comment_id = null
      this.level = 1
      this.userForm.type = 0
      this.currentSrc = ''
      this.resultCheck = []
      this.NumRanges = [
        { id: 1, label: '0-5个', minHours: 0, maxHours: 5, flag: false },
        { id: 2, label: '6-10个', minHours: 6, maxHours: 10, flag: false },
        { id: 3, label: '11-20个', minHours: 11, maxHours: 20, flag: false },
        { id: 4, label: '21-50个', minHours: 21, maxHours: 50, flag: false },
      ]
      this.userForm.base_comment_educate_type = '0'
      this.$emit('close')
    },
    handleCloses() {
      this.VirtualVisible = false
    },
    handleUserClose() {
      this.realUserVisible = false
    },
    virtChoose(val) {
      this.virtUser = val
    },
    realChoose(val) {
      this.realUser = val
    },
    radioChange(e) {
      if (e == 2) {
        this.VirtualVisible = true
        this.realUser = []
      } else if (e == 1) {
        this.realUserVisible = true
        this.virtUser = []
      }
    },
    handleRangeSelect(range) {
      // 更新选中的范围
      this.selectedRange = range
      // 从选中的范围对象中获取小时数的上下限
      const { minHours, maxHours, label } = range

      // 生成 [minHours, maxHours] 之间的一个随机整数
      const randomHours = Math.random() * (maxHours - minHours) + minHours

      // 获取当前时间的时间戳 (毫秒)
      const nowTimestamp = Date.now()

      // 计算目标时间的时间戳
      // 1小时 = 3600000 毫秒
      const targetTimestamp = nowTimestamp - randomHours * 3600000

      // 将目标时间戳格式化为易读的字符串
      const targetTimeString = new Date(targetTimestamp).toLocaleString()

      // 将所有结果存入 result 对象，用于在模板中展示
      this.timeResult = {
        selectedLabel: label,
        randomHours: randomHours,
        timestamp: Math.floor(targetTimestamp),
        targetTimeString: targetTimeString,
      }
      this.$set(
        this.userForm,
        'admin_finger_create_time',
        this.timeResult.timestamp
      )
    },
    // 配置列表查询
    fetchConfigureList() {
      configureList().then((res) => {
        if (res) {
          this.configureList = res.list
        }
      })
    },
    open() {
      if (location.host.includes('admin.kaoyanbox.com')) {
        this.currentSrc = `https://senior.kaoyanbox.com/#/graduatA/experienceDatail/index?id=${this.detailId}`
      } else {
        this.currentSrc = `https://test-senior.kaoyanbox.net/#/graduatA/experienceDatail/index?id=${this.detailId}`
      }
      this.fetchConfigureList()
      this.getCategoryList()
      this.getCommentList()
      this.oneComment()
    },
    handleLike(range) {
      range.flag = !range.flag
      if (range.flag) {
        this.NumRanges.map((item) => {
          if (item.id != range.id) {
            item.flag = false
          }
        })
      }
    },
    confirmComment() {
      if (this.chooseCommentList.length > 1) {
        this.$message.error('只能选择一条数据')
        return
      }
      this.commentShow = false
    },
    concleComment() {
      this.commentShow = false
      this.chooseCommentList = []
    },
    submit() {
      if (this.userForm.content == '') {
        this.$message.error(`请填写评论`)
        return
      }
      if (this.virtUser.length == 0 && this.realUser == 0) {
        this.$message.error(`请选择发布人`)
        return
      }
      //基础评论量
      let hasOutOfStock = this.NumRanges.some(function (product) {
        return product.flag == true
      })
      if (hasOutOfStock) {
        let checkItem = null
        this.NumRanges.map((item) => {
          if (item.flag) {
            checkItem = item
          }
        })
        const { minHours, maxHours, label } = checkItem
        this.rangeNum =
          Math.floor(Math.random() * (maxHours - minHours + 1)) + minHours

        if (this.resultCheck.length == 0) {
          this.$message.error(`请选择评论分类`)
          return
        }
      }

      let data = {
        note_id: this.detailId,
        level: 1,
        content: this.userForm.content,
        admin_finger_create_time: this.userForm.admin_finger_create_time,
      }
      if (this.level == 2) {
        data.target_note_comment_id = this.target_note_comment_id
        data.level = 2
      }

      if (hasOutOfStock) {
        data.base_comment_count = this.rangeNum
        data.base_comment_educate_type = this.userForm.base_comment_educate_type
        data.base_comment_category_ids = this.resultCheck.join(',')
      }

      if (this.userForm.type == 2) {
        data.admin_finger_uid = this.virtUser[0].uid
      } else if (this.userForm.type == 1) {
        data.admin_finger_uid = this.realUser[0].uid
      }
      commentCrtaed(data).then((res) => {
        this.userForm.content = ''
        this.virtUser = []
        this.realUser = []
        this.userForm.admin_finger_create_time = null
        this.currentSrc = ''
        this.userForm.type = 0
        this.resultCheck = []
        this.NumRanges = [
          { id: 1, label: '0-5个', minHours: 0, maxHours: 5, flag: false },
          { id: 2, label: '6-10个', minHours: 6, maxHours: 10, flag: false },
          { id: 3, label: '11-20个', minHours: 11, maxHours: 20, flag: false },
          { id: 4, label: '21-50个', minHours: 21, maxHours: 50, flag: false },
        ]
        this.chooseCommentList = []
        this.target_note_comment_id = null
        setTimeout(() => {
          if (location.host.includes('admin.kaoyanbox.com')) {
            this.currentSrc = `https://senior.kaoyanbox.com/#/graduatA/experienceDatail/index?id=${this.detailId}`
          } else {
            this.currentSrc = `https://test-senior.kaoyanbox.net/#/graduatA/experienceDatail/index?id=${this.detailId}`
          }
        }, 300)
      })
    },
  },
}
</script>
<style scoped lang="less">
::v-deep .el-dialog__header {
  background: #ecf2fe;
}
.content {
  padding-top: 32px;
  padding-bottom: 32px;
  display: flex;
  justify-content: space-between;
  position: relative;
  .auditContent {
    width: 600px;
    display: flex;
    justify-content: space-between;
    padding-left: 32px;
  }
  .auditRight {
    width: 900px;
    .audirTop {
      margin-bottom: 15px;
      display: flex;
      align-items: center;
      font-weight: 700;
      color: #303133;
      .blue {
        margin-right: 6px;
        width: 4px;
        height: 16px;
        background: #1f86fe;
        border-radius: 4px 4px 4px 4px;
        display: inline-block;
      }
    }

    .auditTop {
      display: flex;
      align-items: center;
      float: left;
      .blue {
        margin-right: 5px;
        display: inline-block;
        width: 4px;
        height: 12px;
        background: #1f86fe;
        border-radius: 4px 4px 4px 4px;
      }
    }
    .timeGroup {
      width: 380px;
      height: 40px;
      display: flex;
      justify-content: space-between;

      .timeItem {
        color: #409eff;
        cursor: pointer;
      }
    }
    .rangeContent {
      width: 400px;
      display: flex;
      flex-flow: wrap;

      .rangeItem {
        cursor: pointer;
        margin-bottom: 16px;
        margin-right: 20px;
        border-radius: 0px 0px 0px 0px;
        border: 1px solid #dcdcdc;
        padding: 0px 4px;
        position: relative;
        .checkImg {
          position: absolute;
          bottom: 0px;
          right: 0px;
          width: 14.16px;
          height: 12.5px;
        }
      }
      .active {
        border: 1px solid #1f86fe;
      }
    }
    .footer {
      width: 120px;
      margin-left: 350px;
      // float: right;
      display: flex;
      margin-right: -70px;
      .cancle {
        font-weight: 400;
        font-size: 14px;
        color: #909399;
        width: 56px;
        text-align: center;
        height: 36px;
        line-height: 36px;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #dcdfe6;
        margin-right: 20px;
      }
      .confirm {
        text-align: center;
        width: 56px;
        height: 36px;
        font-size: 14px;
        color: #ffffff;
        line-height: 36px;
        background: #409eff;
        border-radius: 4px 4px 4px 4px;
      }
    }
  }
}
.footers {
  width: 120px;
  // margin-left: 350px;
  // float: right;
  display: flex;
  // margin-right: -70px;
  .cancle {
    font-weight: 400;
    font-size: 14px;
    color: #909399;
    width: 56px;
    text-align: center;
    height: 36px;
    line-height: 36px;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #dcdfe6;
    margin-right: 20px;
  }
  .confirm {
    text-align: center;
    width: 56px;
    height: 36px;
    font-size: 14px;
    color: #ffffff;
    line-height: 36px;
    background: #409eff;
    border-radius: 4px 4px 4px 4px;
  }
}
</style>